import { Input, InputProps } from 'antd'
import cls from 'classnames'
import styles from './ASearch.module.less'
import { useState } from 'react'
import AIcon from '../AIcon/AIcon'

const COMPONENT_NAME = 'A-Search'

type Props = Pick<
  InputProps,
  'placeholder' | 'value' | 'className' | 'allowClear' | 'onBlur' | 'onClick'
> & {
  filled?: 'white' | 'gray'
  testId?: string
  onSearch?: (value: InputProps['value']) => void
}

function ASearch(props: Props) {
  const [value, setValue] = useState(props.value)
  const classNames = cls(styles[COMPONENT_NAME], props.className, {
    [styles.filledGray]: props.filled && props.filled === 'gray',
  })

  const handleSearch = (_value: InputProps['value']) => {
    props.onSearch?.(_value)
  }

  return (
    <Input
      data-testid={props.testId}
      size='large'
      className={classNames}
      value={value}
      allowClear={props.allowClear}
      onBlur={props.onBlur}
      onClick={props.onClick}
      placeholder={props.placeholder}
      prefix={<AIcon type='icon-line-global_search' width={20} height={20} />}
      onChange={({ target }) => {
        setValue(target.value)
      }}
      onClear={() => {
        handleSearch('')
      }}
      onPressEnter={() => handleSearch(value)}
    />
  )
}

export default ASearch
